export default "__VITE_ASSET___XO_cbBu__"